import { MimeContentType } from '../enums/mime-content-type.enum';

export const PLAIN_TEXT_TYPES = [MimeContentType.Text];
